export type ExploreTab = "companies" | "experts" | "corridors" | "expos";

export const CLIENT_EXPLORE_PATH = "/my-discovery";
export const GUEST_EXPLORE_PATH = "/discover";

const VALID_TABS = new Set<ExploreTab>(["companies", "experts", "corridors", "expos"]);

export function parseExploreTabParam(value: string | null): ExploreTab {
  if (value === "experts" || value === "corridors" || value === "expos") return value;
  return "companies";
}

export function isExploreTab(value: string | null): value is ExploreTab {
  return VALID_TABS.has(parseExploreTabParam(value));
}

export function exploreTabHref(basePath: string, tab: ExploreTab): string {
  return tab === "companies" ? basePath : `${basePath}?tab=${tab}`;
}

export function guestExploreBasePath(pathname: string): string {
  return pathname === GUEST_EXPLORE_PATH ? GUEST_EXPLORE_PATH : "/";
}

export function guestExploreTabHref(pathname: string, tab: ExploreTab): string {
  return exploreTabHref(guestExploreBasePath(pathname), tab);
}

export const EXPLORE_EXPERTS_TAB = `${CLIENT_EXPLORE_PATH}?tab=experts`;
export const EXPLORE_CORRIDORS_TAB = `${CLIENT_EXPLORE_PATH}?tab=corridors`;

export const GUEST_EXPLORE_EXPERTS_TAB = `${GUEST_EXPLORE_PATH}?tab=experts`;
export const GUEST_EXPLORE_CORRIDORS_TAB = `${GUEST_EXPLORE_PATH}?tab=corridors`;

export const EXPLORE_TAB_SUBTITLES: Record<ExploreTab, string> = {
  companies: "Browse verified companies and partnership opportunities.",
  experts: "Verified sector experts who guide cross-border partnerships.",
  corridors: "Cross-border trade corridors led by ecosystem heads.",
  expos: "Upcoming global industry expos and exhibitions.",
};
